import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function ShirtIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M9 4l3 2 3-2 5 3-2 4-2-1v10H8V10l-2 1-2-4z" />
    </LineIcon>
  );
}
